<div mat-dialog-title class="dialog-header">
  <span class="title">
    {{
      (data.mode === "create"
        ? "view_value.add_admin"
        : "view_value.edit_admin"
      ) | translate
    }}
  </span>
  <button mat-icon-button mat-dialog-close class="icon-btn-close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="form">
    <div class="grid">
      <div class="field">
        <label>
          {{ "view_value.first_name" | translate }}
          <span *ngIf="form.controls['first_name'].validator" class="required"
            >*</span
          >
        </label>

        <mat-form-field appearance="outline" class="full-width">
          <input
            matInput
            formControlName="first_name"
            [placeholder]="'view_value.first_name' | translate"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label>
          {{ "view_value.last_name" | translate }}
          <span *ngIf="form.controls['last_name'].validator" class="required"
            >*</span
          >
        </label>

        <mat-form-field appearance="outline" class="full-width">
          <input
            matInput
            formControlName="last_name"
            [placeholder]="'view_value.last_name' | translate"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label>
          {{ "view_value.email" | translate }}
          <span *ngIf="form.controls['email'].validator" class="required"
            >*</span
          >
        </label>

        <mat-form-field appearance="outline" class="full-width">
          <input
            matInput
            formControlName="email"
            [placeholder]="'view_value.email' | translate"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label>
          {{ "view_value.phone" | translate }}
          <span *ngIf="form.controls['tel_no'].validator" class="required"
            >*</span
          >
        </label>

        <mat-form-field appearance="outline" class="full-width">
          <input
            matInput
            formControlName="tel_no"
            [placeholder]="'view_value.phone' | translate"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label>
          {{ "view_value.access_permissions" | translate }}
          <span *ngIf="form.controls['role'].validator" class="required"
            >*</span
          >
        </label>

        <mat-form-field appearance="outline" class="full-width">
          <mat-select
            formControlName="role"
            [placeholder]="'view_value.access_permissions' | translate"
          >
            <mat-option *ngFor="let item of data.roleOptions" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="field">
        <label>
          {{ "view_value.status" | translate }}
          <span *ngIf="form.controls['status'].validator" class="required"
            >*</span
          >
        </label>

        <mat-form-field appearance="outline" class="full-width">
          <mat-select
            formControlName="status"
            [placeholder]="'view_value.select_status' | translate"
          >
            <mat-option
              *ngFor="let item of data.statusOptions"
              [value]="item.value"
            >
              {{ item.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <p class="hint">
      {{
        "view_value.confirm_hint_test"
          | translate
            : {
                action:
                  data.mode === "create"
                    ? ("view_value.save" | translate)
                    : ("view_value.edit" | translate),
              }
      }}
    </p>

    <div class="actions">
      <button
        mat-stroked-button
        class="btn-outline"
        type="button"
        (click)="close()"
      >
        <mat-icon>close</mat-icon>
        {{ "view_value.cancel" | translate }}
      </button>

      <button
        mat-flat-button
        class="btn-primary"
        type="button"
        (click)="submit()"
      >
        <mat-icon>save_as</mat-icon>
        {{
          data.mode === "create"
            ? ("view_value.add_admin" | translate)
            : ("view_value.save" | translate)
        }}
      </button>
    </div>
  </form>
</mat-dialog-content>
